import { render } from "./Amplitude.vue?vue&type=template&id=0c7e0e8b"
import script from "./Amplitude.vue?vue&type=script&lang=js"
export * from "./Amplitude.vue?vue&type=script&lang=js"

import "./Amplitude.vue?vue&type=style&index=0&id=0c7e0e8b&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__